import React, { useEffect, useState } from "react";
import "../../assets/css/agent/tickets.scss";
import { Link, useHistory, useLocation } from "react-router-dom";
import axiosInstance from '../../environment/axiosInstance';
import moment from "moment";
import ReactPaginate from 'react-paginate';
import "../../assets/css/pagination.scss";
import { BsCircle } from "react-icons/bs";
import { AiOutlinePlus } from "react-icons/ai";
import Dropdown from 'react-bootstrap/Dropdown';
import { ToastContainer, toast } from 'react-toastify';

function AllCustomers(props) {
    const history = useHistory();
    const [customers, setCustomers] = useState([]);
    const [customersCount, setCustomersCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [page, setPage] = useState(1);

    const toastError = (message) => {
        toast.error(message);
    }

    const toastSuccess = (message) => {
        toast.success(message);
    }

    const useQuery = () => {
        const { search } = useLocation();

        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    let searchParams = useQuery();

    useEffect(() => {
        let page = 1;

        if (searchParams.get("page")) {
            page = searchParams.get("page");
        }

        setPage(page);
        fetchCustomers(page);
    }, [searchParams.get("page")]);

    const fetchCustomers = (page) => {
        axiosInstance
            .get(process.env.REACT_APP_API_URL + "/support/business_owner/customer?page=" + page, {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("user_token")}`
                }
            })
            .then(response => {
                if (response.data) {
                    setCustomers(response.data.Data.docs);
                    setCustomersCount(response.data.Data.totalDocs);
                    setTotalPages(response.data.Data.totalPages);
                }
            });
    }

    const handlePageClick = (event) => {
        history.push("/dashboard/customers?page=" + (event.selected + 1));
    }

    return (
        <div>
            <div className="tickets-content">
                <div className="top-row mb-4">
                    <p className="m-0 title">Customers List<span className="count"> ({customersCount})</span></p>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center"></div>
                        {/* <div className="d-flex align-items-center justify-content-end">
                            <input
                                type="text"
                                className="form-control search-ticket"
                                value=""
                                placeholder="Search Customer"
                            />
                        </div> */}
                    </div>
                </div>
                <table className="tickets-table table">
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Created On</th>
                        <th className="text-center">Status</th>
                        <th className="text-center">Action</th>
                    </tr>
                    {
                        customers?.length > 0 ?
                            customers?.map(customer => {
                                return (
                                    <tr>
                                        <td style={{ padding: "10px" }}>{customer._id}</td>
                                        <td style={{ padding: "10px" }}>{customer.customer_name}</td>
                                        <td style={{ padding: "10px" }}>{customer.customer_email}</td>
                                        <td style={{ padding: "10px" }}>
                                            {moment(customer.createdAt).format("D-MM-YYYY")}
                                        </td>
                                        <td
                                            className="status text-center"
                                            style={{ padding: "10px" }}
                                        >
                                            {
                                                customer.status == 1 ?
                                                    "Active"
                                                    :
                                                    "Inactive"
                                            }
                                        </td>
                                        <td
                                            className="text-center"
                                            style={{ padding: "10px" }}
                                        >
                                            <Link
                                                to={"/conversations/" + customer._id}
                                                className="view-btn"
                                            >View</Link>
                                        </td>
                                    </tr>
                                )
                            })
                            :
                            <p>No customers found.</p>
                    }
                </table>
                <ReactPaginate
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={totalPages}
                    previousLabel="<"
                    renderOnZeroPageCount={null}
                    className="pagination"
                    activeClassName="active-page"
                    forcePage={page - 1}
                />
            </div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            {/* Same as */}
            <ToastContainer />
        </div>
    )
}

export default AllCustomers;